import {
  BRAND_COLOR_PRESETS,
  DEFAULT_BRAND_COLOR,
  getBrandColorValue,
} from 'shared/constants/brandColorPresets';
import { getReadableTextColor } from 'shared/helpers/colorHelper';

/**
 * Applies the brand color preset as CSS custom properties on :root
 * Called on app boot to dynamically theme the woot color scale
 */
export function applyBrandColor(colorKey = null) {
  const key =
    colorKey || window.globalConfig?.BRAND_COLOR || DEFAULT_BRAND_COLOR;
  const preset = getBrandColorValue(key);

  if (!preset) return;

  const root = document.documentElement;

  Object.entries(preset.scale).forEach(([shade, hex]) => {
    root.style.setProperty(`--woot-${shade}`, hex);
  });

  // Set --n-brand-rgb as space-separated RGB for Tailwind opacity support
  const hex = preset.hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  root.style.setProperty('--n-brand-rgb', `${r} ${g} ${b}`);
  root.style.setProperty(
    '--n-brand-contrast',
    getReadableTextColor(preset.hex)
  );
}

/**
 * Returns the list of available brand color options for the selector
 */
export function getBrandColorOptions() {
  return Object.entries(BRAND_COLOR_PRESETS).map(([key, preset]) => ({
    key,
    name: key,
    hex: preset.hex,
  }));
}
